module.exports = __webpack_public_path__ + "static/1073-4efdd0b18fc970c9fd7a1137d57ca053.png";